import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SeventhStep = function SeventhStep(_ref) {
  var setStep = _ref.setStep,
    isKycFailed = _ref.isKycFailed,
    isBankVerificationFailed = _ref.isBankVerificationFailed;
  return /*#__PURE__*/_jsxs("div", {
    className: "py-3 flex flex-col justify-center items-center text-center",
    children: [isKycFailed && /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col items-center p-4 text-center",
      children: [/*#__PURE__*/_jsx("p", {
        className: "text-gray-800 text-lg mb-1",
        children: "Facing issues with eKYC?"
      }), /*#__PURE__*/_jsx("a", {
        href: "/myprofile/docs",
        className: "text-blue-600 font-semibold underline cursor-pointer",
        children: "Upload documents manually"
      })]
    }), isBankVerificationFailed && /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col items-center text-center",
      children: [/*#__PURE__*/_jsx("p", {
        className: "text-gray-800 text-lg mb-1",
        children: "Facing issues with bank verification?"
      }), /*#__PURE__*/_jsx("a", {
        href: "/myprofile/docs",
        className: "text-blue-600 font-semibold underline cursor-pointer",
        children: "Upload documents manually"
      })]
    })]
  });
};
export default SeventhStep;